export enum AdOfferStatus {
  Pending = 10,
  Accepted = 20,
  Rejected = 30,
  Countered = 40,
  RejectCounter = 50
}
